import Vue from 'vue'
import Vuex from 'vuex'
import router from './../router/index.js'

Vue.use(Vuex)
const state = {
    userinfo: {},
    permissionList: [],
    permission: {},
    searchConfig: {},
    pageNumbers: {},
    projectRole: null,
    allRoutes: [
        {
            label: '原始记录',
            options: [
                // {value: 'record_zg_index', label: '原始记录直观版'},
                {value: 'record_cma_index', label: '原始记录CMA版'},
                {value: 'site_doc', label: '原始记录档案'}
            ]
        },
        {
            label: '报告书',
            options: [
                {value: 'report_zg_index', label: '报告书直观版'},
                {value: 'report_cma_index', label: '报告书CMA版'}
            ]
        },
        {
            label: '其他',
            options: [
                {value: 'site_down', label: '下载'},
                {value: 'site_check', label: '复检'},
                {value: 'site_notice', label: '生成告知书'}
            ]
        }
    ]
}
let getters = {
    hasPermission: (state) => (per) => {
        return state.permission[per]
    },
    allRoutes: state => state.allRoutes,

}
let mutations = {
    GET_ROUTE_LIST(state) {
        let userinfo = Vue.$Config.userinfo
        let token = userinfo.token || null
        if (!token) { //没有用户信息则跳转到登录界面
            router.push({name: 'login'})
            return
        }
        state.userinfo = userinfo
    },
    SET_USER_INFO(state, userinfo) {
        state.userinfo = Object.assign({}, state.userinfo, userinfo)
        Vue.$Config.userinfo.employee_id = state.userinfo.employee_id
        Vue.$Config.userinfo.employee_name = state.userinfo.employee_name
        Vue.$Config.userinfo.token = state.userinfo.token
    },
    SET_PERMISSION_LIST(state, list) {
        state.permissionList = list
    },
    SET_PERMISSION(state, obj) {
        state.permission = obj
    },
    SET_SEARCH_CONFIG(state, payload) {
        state.searchConfig = payload
    },
    SET_PAGE_NUMBER(state, {projectId, pageNumber}) {
        Vue.set(state.pageNumbers, projectId, pageNumber)
    },
    SET_PROJECT_PERMISSION(state,{role}){
        state.projectRole = role;
    }
}
let actions = {
    async getUserinfo({state, commit, dispatch}) {
        if (state.userinfo.employee_id) {
            return true
        }
        let userinfo = Vue.$Config.userinfo
        if (userinfo) {
            commit('SET_USER_INFO', userinfo)
            return true
        } else {
            return false
        }
    },
    async initUserinfo({commit, dispatch}, userinfo) {
        commit('SET_USER_INFO', userinfo)
        localStorage.setItem('userinfo', JSON.stringify(userinfo))
    },
    async initPermission({state, commit}) {
        if (state.permissionList.length) {
            return true
        }
        try {
            let list = await Vue.$Api.post('get_permission', {employee_id2: state.userinfo.employee_id})
            if (!list) {
                return
            }
            commit('SET_PERMISSION_LIST', list)
            let obj = {}
            for (let item of list) {
                obj[item] = true
            }
            commit('SET_PERMISSION', obj)
            return true
        } catch (e) {
            router.push({name: 'login'})
        }
    },
    clearinfo({commit}) {
        commit('SET_USER_INFO', {})
        commit('SET_PERMISSION_LIST', [])
        commit('SET_PERMISSION', {})
        localStorage.removeItem('userinfo')
        router.push({name: 'login'})
    },
    updateSearchConfig({commit}, payload) {
        commit('SET_SEARCH_CONFIG', payload)
    }

}
let store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    strict: false,
})
Vue.$Store = Vue.prototype.$Store = store

export default store